// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import bgImage from 'assets/images/bg-orange.png';
import {
  Container, Title, GoalcardCard, InformationContainer, InformationDetails, DetailLabel, Amount,
} from './Styles';

type GoalcardPreviewProps = {
  userId: string,
  receiverName: string,
  investorName: string,
  cardImageUrl: string,
  goalPrettyName: string,
  amount: float
};

const GoalcardPreview = (props: GoalcardPreviewProps) => {
  const { t } = useTranslation();
  const {
    userId, receiverName, investorName, amount, cardImageUrl, goalPrettyName,
  } = props;

  const RenderFor = () => {
    if (!userId || goalPrettyName) {
      return (
        <DetailLabel>
          {t('customize_for_title')}
          {goalPrettyName || t('customize_forpreset_title')}
        </DetailLabel>
      );
    }

    return null;
  };

  const parsedAmount = amount || 0;

  return (
    <Container backgroundImage={bgImage}>
      <Title>GoalCard</Title>
      <GoalcardCard src={cardImageUrl} />
      <InformationContainer>
        <InformationDetails>
          <DetailLabel data-testid="lblReceiver">
            {t('customize_to_title', { receiverName })}
          </DetailLabel>
          <DetailLabel data-testid="lblInvestor">
            {t('customize_from_title', { investorName })}
          </DetailLabel>
          {RenderFor()}
        </InformationDetails>
        <Amount data-testid="lblAmount">
          $
          {parsedAmount.toFixed(2)}
        </Amount>
      </InformationContainer>
    </Container>
  );
};

export default GoalcardPreview;
